import { Observable } from "rxjs";
import NetworkService from "../network/networkService";
import { OdQueryParam } from "../enums";
import { helperFunctions } from "../helper";
import { URLConfig } from "../network/urlStore";
import { IUserPreferencesAllResponse } from "../models/IUserPreferences.model";

export const getUserPreferences = (
  queryParams?: Array<{
    key: OdQueryParam;
    value: string[];
  }>
): Observable<IUserPreferencesAllResponse> => {
  let url = URLConfig.getUserPreferencesURL();
  for (let param of queryParams || []) {
    url = helperFunctions.addQueryParam(url, param.key, param.value);
  }
  return new Observable((subscriber) => {
    NetworkService.get(url).then(
      (res: unknown) => {
        const response = res as IUserPreferencesAllResponse;
        subscriber.next(response);
        subscriber.complete();
      },
      (error: Error) => {
        subscriber.error(error);
        console.log("Error while fetching crops master data", error);
      }
    );
  });
};

export const createUserPreferences = (
  preferencePayload: any
): Observable<IUserPreferencesAllResponse> => {
  let url = URLConfig.getUserPreferencesURL();
  return new Observable((subscriber) => {
    NetworkService.post(url, preferencePayload).then(
      (res: unknown) => {
        subscriber.next(res as IUserPreferencesAllResponse);
        subscriber.complete();
      },
      (error: Error) => {
        subscriber.error(error);
        console.log("Error while fetching crops master data", error);
      }
    );
  });
};
export const updateUserPreferences = (
  preferencePayload: any,
  preferenceId: string
): Observable<IUserPreferencesAllResponse> => {
  let url = URLConfig.getUserPreferencesURL(preferenceId);
  return new Observable((subscriber) => {
    NetworkService.put(url, preferencePayload).then(
      (res: unknown) => {
        subscriber.next(res as IUserPreferencesAllResponse);
        subscriber.complete();
      },
      (error: Error) => {
        subscriber.error(error);
        console.log("Error while fetching crops master data", error);
      }
    );
  });
};
export const deleteUserPreferences = (
  preferenceId: string
): Observable<IUserPreferencesAllResponse> => {
  let url = URLConfig.getUserPreferencesURL(preferenceId);
  return new Observable((subscriber) => {
    NetworkService.delete(url).then(
      (res: unknown) => {
        subscriber.next(res as IUserPreferencesAllResponse);
        subscriber.complete();
      },
      (error: Error) => {
        subscriber.error(error);
        console.log("Error while fetching crops master data", error);
      }
    );
  });
};
